/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAssignVariable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18.274 12.297a1.014 1.014 0 0 1 1.433 0l2.981 2.98c.396.396.396 1.038.001 1.433l-5.274 5.294H13V17.59zM9.213 3C7.598 4.538 6.37 6.265 5.531 8.181a14.995 14.995 0 0 0-1.259 6.088c0 1.185.126 2.37.378 3.555.253 1.184.606 2.243 1.061 3.176H3.666c-.315-.517-.6-1.16-.852-1.929-.252-.768-.451-1.582-.596-2.439S2 14.956 2 14.174c0-1.462.196-2.886.587-4.273.391-1.386.953-2.672 1.685-3.857S5.869 3.845 6.866 3zm9.778 11.409L15 18.416v1.587h1.584l3.993-4.008zm-8.26-7.155 1.515 3.366 2.707-3.366h2.5l-4.147 4.897 1.432 2.85h-2.33l-.71-1.488L8.742 17.2H6.225l4.393-5.238L8.27 7.254zM20.334 3c.315.517.6 1.16.852 1.929.252.768.451 1.582.596 2.439.146.857.218 1.676.218 2.458 0 .276-.016.687-.049 1.232l-2.28-.032c.038-.572.057-1.004.057-1.295 0-1.197-.126-2.389-.378-3.573-.253-1.185-.606-2.238-1.06-3.158z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAssignVariable as AssignVariable };
